import { Link } from 'react-router-dom'
import SEO from '@components/SEO'
import { ROUTES } from '@constants'
import images from '@assets/images'
import './NotFoundPage.css'

function NotFoundPage() {
  return (
    <main className="notfound-page">
      <SEO
        title="404 – Không tìm thấy trang"
        description="Đường dẫn bạn yêu cầu không tồn tại hoặc đã bị gỡ bỏ trên hệ thống Fenica."
      />

      {/* Background layers */}
      <div className="notfound-page__grid" aria-hidden="true" />
      <div className="notfound-page__glow notfound-page__glow--1" aria-hidden="true" />
      <div className="notfound-page__glow notfound-page__glow--2" aria-hidden="true" />
      <div className="notfound-page__glow notfound-page__glow--3" aria-hidden="true" />

      {/* Logo */}
      <Link to={ROUTES.HOME} className="notfound-page__logo" aria-label="Fenica – Trang chủ">
        <img src={images.logo} alt="Fenica Logo" />
      </Link>

      <div className="notfound-page__container">
        {/* Decorative label */}
        <span className="notfound-page__label">ERROR</span>

        <div className="notfound-page__code">404</div>

        <h1 className="notfound-page__title">KHÔNG TÌM THẤY TRANG</h1>
        <p className="notfound-page__subtitle">PAGE NOT FOUND</p>

        <div className="notfound-page__divider">
          <span className="notfound-page__divider-line" />
          <span className="notfound-page__divider-dot" />
          <span className="notfound-page__divider-line" />
        </div>

        <p className="notfound-page__desc">
          Đường dẫn bạn đang truy cập không tồn tại, đã bị xóa hoặc chuyển sang một địa chỉ khác.
          Vui lòng kiểm tra lại URL hoặc quay trở lại trang chủ.
        </p>

        <Link to={ROUTES.HOME} className="notfound-page__btn">
          <span className="notfound-page__btn-shimmer" aria-hidden="true" />
          Quay Về Trang Chủ
        </Link>
      </div>

      <footer className="notfound-page__footer">
        © {new Date().getFullYear()} FENICA. All rights reserved.
      </footer>
    </main>
  )
}

export default NotFoundPage
